import React, { useState } from "react";

const ServicesCarousel = () => {
  const services = [
    {
      id: 1,
      title: "Web Development",
      desc: "Building high-performance websites tailored to your business needs.",
      iconPath:
        "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01",
    },
    {
      id: 2,
      title: "Mobile Apps",
      desc: "Creating intuitive mobile experiences for iOS and Android.",
      iconPath:
        "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    },
    {
      id: 3,
      title: "Cloud Solutions",
      desc: "Secure and scalable cloud infrastructure for modern businesses.",
      iconPath:
        "M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z",
    },
    {
      id: 4,
      title: "Data Analytics",
      desc: "Turning raw data into actionable business insights.",
      iconPath:
        "M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879M12 12L9.121 9.121m0 5.758a3 3 0 10-4.243 4.243 3 3 0 004.243-4.243zm0-5.758a3 3 0 10-4.243-4.243 3 3 0 004.243 4.243z",
    },
    {
      id: 5,
      title: "Cyber Security",
      desc: "Protecting your digital assets with advanced protocols.",
      iconPath:
        "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    },
    {
      id: 6,
      title: "IT Consulting",
      desc: "Expert advice to optimize your technology strategy.",
      iconPath:
        "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const translateX = -(currentIndex * 33.33);

  const handleNext = () => {
    const maxIndex = services.length - 3;
    if (currentIndex < maxIndex) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setCurrentIndex(0);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    } else {
      setCurrentIndex(services.length - 3);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center text-slate-900 mb-12 tracking-tight">
        Our <span className="text-blue-600">Services</span>
      </h2>

      {/* Carousel Container */}
      <div className="relative group">
        {/* Slides Track */}
        <div className="overflow-hidden py-4">
          <div
            className="flex transition-transform duration-500 ease-out"
            style={{ transform: `translateX(${translateX}%)` }}
          >
            {services.map((service) => (
              <div
                key={service.id}
                className="min-w-full md:min-w-[33.33%] p-4"
              >
                {/* --- CARD START --- */}
                <div className="group bg-white border border-blue-900 rounded-2xl shadow-lg hover:shadow-2xl p-8 text-center h-full cursor-pointer transition-all duration-300 hover:bg-white hover:scale-[1.02]">
                  {/* Icon Circle: Glassy Dark Look */}
                  <div className="bg-blue-600/90 border w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6 transition-colors duration-300 group-hover:bg-blue-600/40">
                    <svg
                      className="w-10 h-10 text-white group-hover:text-slate-900 transition-colors"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d={service.iconPath}
                      />
                    </svg>
                  </div>

                  {/* Title: White */}
                  <h3 className="text-2xl font-bold mb-3 text-slate-900 group-hover:text-slate-900 transition-colors">
                    {service.title}
                  </h3>

                  {/* Description: White/Grey */}
                  <p className="text-slate-900 group-hover:text-slate-900 transition-colors">
                    {service.desc}
                  </p>
                </div>
                {/* --- CARD END --- */}
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Buttons */}
        <button
          onClick={handlePrev}
          className="absolute top-1/2 left-0 -translate-y-1/2 -translate-x-2 md:-translate-x-6 bg-white p-3 rounded-full shadow-lg text-blue-600 hover:bg-blue-50 hover:text-blue-700 focus:outline-none z-10 transition hidden sm:block"
          aria-label="Previous"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          onClick={handleNext}
          className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-2 md:translate-x-6 bg-white p-3 rounded-full shadow-lg text-blue-600 hover:bg-blue-50 hover:text-blue-700 focus:outline-none z-10 transition hidden sm:block"
          aria-label="Next"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>

        {/* Indicators */}
        <div className="flex justify-center mt-8 space-x-2">
          {[...Array(services.length - 2).keys()].map((idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`h-2 rounded-full transition-all duration-300 ${
                currentIndex === idx
                  ? "w-8 bg-blue-600"
                  : "w-2 bg-slate-300 hover:bg-slate-400"
              }`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesCarousel;
